export const toOrgStoryForm = (story) => ({
    id: story.id,
    title: story.title,
    description: story.description,
    status: story.status,
    headerAssetId: story.headerAssetId,
    timelineIds: story.timelineIds,
    assetIds: story.assetIds,
    residentIds: story.residentIds,
});
// A published view is for everyone; a draft only for those who may edit it.
export const isStoryVisible = (story) => story.status === 'published' || story.canEdit;
